import React from 'react';
import classnames from 'classnames';
import PropTypes from 'prop-types';

import { Form } from 'core/forms';

import styles from '../styles/uikitModalsModalContent.module.scss';

const ModalContent = ({
  modal,
  modalData,
  onActionClicked = () => {},
  onCloseButtonClicked = () => {},
  onFormLoad = () => {},
  onFormUpdate = () => {},
}) => {
  if (!modal.component && !modal.schema) return null;

  return (
    <div className={classnames(styles.element, modal.isFullScreen && styles.isFullScreen)}>
      {modal.component && React.isValidElement(modal.component) && (
        React.cloneElement(modal.component, {
          onActionClicked,
          onCloseButtonClicked,
        })
      )}
      {modal.schema && (
        <div className={styles.form}>
          <Form
            schema={modal.schema}
            model={modalData}
            onLoad={onFormLoad}
            onUpdate={onFormUpdate}
          />
        </div>
      )}
    </div>
  );
};

ModalContent.propTypes = {
  modal: PropTypes.shape({
    component: PropTypes.object,
    schema: PropTypes.shape({}),
    isFullScreen: PropTypes.bool,
  }).isRequired,
  modalData: PropTypes.shape({}).isRequired,
  onActionClicked: PropTypes.func,
  onCloseButtonClicked: PropTypes.func,
  onFormLoad: PropTypes.func,
  onFormUpdate: PropTypes.func,
};

export default ModalContent;
